<template>
  <div>
    <list
      row-key="ParentId"
      ref="list"
      unit="家长账号"
      :page="page"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学生身份证" label-width="90px">
          <el-input v-model="params.StudentIdCard" placeholder="请输入学生身份证" clearable />
        </el-form-item>
        <el-form-item label="手机号" label-width="90px">
          <el-input v-model="params.Mobile" placeholder="请输入手机号" clearable />
        </el-form-item>
        <el-form-item label="注册类型" label-width="90px">
          <el-select v-model="params.RegType" placeholder="请选择注册类型" clearable>
            <el-option label="家长注册" :value="0"></el-option>
            <el-option label="后台添加" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" label-width="90px" v-if="showStatus">
          <el-select v-model="params.Status" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="归档状态" label-width="90px" v-if="showStatus">
        <el-select v-model="params.FileStatus" placeholder="请选择归档状态" clearable>
            <el-option label="已归档" :value="1"></el-option>
            <el-option label="未归档" :value="0"></el-option>
        </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="StudentIdCard" label="学生身份证" min-width="120px" />
        <el-table-column prop="Mobile" label="手机号" min-width="120px" />
        <el-table-column prop="RegType" label="注册类型" min-width="90px">
          <template slot-scope="{row}">
            <span v-if="row.RegType==0">家长注册</span>
            <span v-if="row.RegType==1">后台添加</span>
          </template>
        </el-table-column>
        <el-table-column prop="AddTime" label="注册时间" min-width="160px" />
        <el-table-column prop="Status" width="80px" label="状态" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.Status == 1">启用</el-tag>
            <el-tag type="danger" v-else>停用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="FileStatus" width="80px" label="归档状态" align="center">
          <template slot-scope="{row}">
            <el-tag type="danger" v-if="row.FileStatus == 1">已归档</el-tag>
            <el-tag type="success" v-else>未归档</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    showStatus: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      api: require("@/api/po/parent").default,
      params: {
        StudentIdCard: "",
        Mobile: "",
        RegType: null,
        Status: null,
        FileStatus:0
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>